export const GET_PROVIDERS = 'src/pages/providers/GET_PROVIDERS';
export const GET_PROVIDERS_SUCCESS =
  'src/pages/providers/GET_PROVIDERS_SUCCESS';
export const GET_PROVIDERS_FAILED = 'src/pages/providers/GET_PROVIDERS_FAILED';

export const UPDATE_PROVIDER_STATUS = 'src/pages/providers/UPDATE_PROVIDER_STATUS';
export const UPDATE_PROVIDER_STATUS_SUCCESS = 'src/pages/providers/UPDATE_PROVIDER_STATUS_SUCCESS';
export const UPDATE_PROVIDER_STATUS_FAILED = 'src/pages/providers/UPDATE_PROVIDER_STATUS_FAILED';

export const CREATE_PROVIDER = 'src/pages/providers/CREATE_PROVIDER';
export const CREATE_PROVIDER_SUCCESS = 'src/pages/providers/CREATE_PROVIDER_SUCCESS';
export const CREATE_PROVIDER_FAILED = 'src/pages/providers/CREATE_PROVIDER_FAILED';
